import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { MoneyFragmentFragmentDoc } from './moneyFragment';
import { CalculationsFragmentFragmentDoc } from './calculationsFragment';
export type EnquiryFragmentFragment = { __typename?: 'Enquiry', id: number, dealId: string, name?: string | null, state: string, certificates?: object | null, billingAccount?: object | null, currency: string, competitorQuoteLink?: string | null, hidePartsDiscounts: boolean, ignoreMinimumOrderValue: boolean, isHighVolume: boolean, lockQuoteLimit: boolean, manualQuotationRequestExpirationDate?: string | null, moderationFinishedAt?: string | null, moderationRequestedAt?: string | null, quotationMethod?: Types.QuotationMethodEnum | null, quotingState: Types.QuotingStateEnum, vatRateIsCustom: boolean, isCanceled: boolean, certificateValues: Array<{ __typename?: 'OmsEnquiryCertificateValue', key: string, positions: number, partIds: Array<string>, amountMoney: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } }>, calculations: { __typename?: 'Calculations', loyalty: { __typename?: 'Loyalty', xPointsCurrencyCoef: number } }, intercompanyObjects?: Array<{ __typename?: 'IntercompanyObject', foreignObjectType: string, foreignRegion: string, id: string, objectType: string, relationType?: Types.RelationEnum | null }> | null, moderationRequestedBy?: { __typename?: 'User', id: number, name: string } | null, totalAmountNetMoney: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum }, fillEnquiry?: { __typename?: 'OmsEnquiryFillEnquiryType', status?: Types.FillEnquiryStatusEnum | null, startedAt: string } | null };

export const EnquiryFragmentFragmentDoc = gql`
    fragment enquiryFragment on Enquiry {
  id
  dealId
  name
  state
  certificates
  certificateValues {
    key
    positions
    partIds
    amountMoney {
      ...moneyFragment
    }
  }
  billingAccount
  currency
  calculations {
    ...calculationsFragment
  }
  competitorQuoteLink
  hidePartsDiscounts
  ignoreMinimumOrderValue
  isHighVolume
  intercompanyObjects {
    foreignObjectType
    foreignRegion
    id
    objectType
    relationType
  }
  lockQuoteLimit
  manualQuotationRequestExpirationDate
  moderationFinishedAt
  moderationRequestedAt
  moderationRequestedBy {
    id
    name
  }
  quotationMethod
  quotingState
  totalAmountNetMoney {
    ...moneyFragment
  }
  vatRateIsCustom
  isCanceled
  fillEnquiry {
    status
    startedAt
  }
}
    ${MoneyFragmentFragmentDoc}
${CalculationsFragmentFragmentDoc}`;